import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'

import { orderStates, showOrderCompleteButtonStatuses } from 'utils/resources'
import { updateStatus } from 'utils/api'
import { fetchAllOrders } from 'store/Orders/actions'
import { getCurrentVenueId } from 'store/Venues/selector'
import { getOrdersApiParamsConfig } from 'store/Orders/selector'

const OrderStatus = ({ order }) => {
  const { uuid } = useParams()
  const dispatch = useDispatch()
  const history = useHistory()

  const venueUuid = useSelector(getCurrentVenueId)
  const ordersApiParamsConfig = useSelector(getOrdersApiParamsConfig)

  const isCompleteButtonVisible = showOrderCompleteButtonStatuses.includes(
    order?.state
  )

  const onClickCompleteOrder = () => {
    updateStatus(uuid, { state: 'completed' })
      .then(() => {
        // when update status is done we have to refetch orders in order to update current order status on the index page
        dispatch(fetchAllOrders({ ...ordersApiParamsConfig, venueUuid }))
      })
      .then(() => {
        history.goBack()
      })
  }

  return (
    <section className="order-details__section order-details__section-highlight -pr-xmd">
      <div className="order-details__row -p-0">
        <span>Current Status</span>
        <span className="order-details__value">
          <span
            className={`order-details__value-dot -dot-${order?.state}`}
          ></span>
          <span>{orderStates[order?.state]}</span>
        </span>
      </div>
      {isCompleteButtonVisible && (
        <button
          className="btn -block -outline -bg-white"
          onClick={onClickCompleteOrder}
        >
          Complete Order
        </button>
      )}
    </section>
  )
}

export default OrderStatus

OrderStatus.propTypes = {
  order: PropTypes.object,
}
